import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { CardTitle } from 'material-ui/Card'
import RaisedButton from 'material-ui/RaisedButton'
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh'
import api from '../../api'
import { setSnackbarMessage } from '../../actions/snackbar'

class RefreshCoachList extends Component<any, any> {
  constructor () {
    super()
    this.state = {
      submitted: false
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.submitRefresh()
  };

  submitRefresh () {
    api.post('admin/coach_users/refresh').then(() => {
      this.setState({ submitted: true })
    })
  }

  render () {
    const { submitted } = this.state

    return (
      <div>
        <CardTitle title='Refresh Coaches List' style={{ paddingLeft: 0 }} />
        {submitted && <p>The coach list has been refreshed.</p>}

        {!submitted && (
          <div>
            <p>
              Use the button below to refresh the list of users that will appear
              on the public coaches page. Coach users are any users who:
            </p>
            <ul>
              <li>Have been assigned the "Coach" role</li>
              <li>Have not been deleted</li>
            </ul>
            <RaisedButton
              label='Refresh'
              primary
              icon={<RefreshIcon />}
              onClick={this.handleSubmit}
            />
          </div>
        )}
      </div>
    )
  }
}

// @ts-ignore
RefreshCoachList.propTypes = {
  setSnackbarMessage: PropTypes.func.isRequired
}

export default connect(null, { setSnackbarMessage })(RefreshCoachList)
